module.exports = __webpack_public_path__ + "img/dashboards_logistics.cb6f0bc9.png";